export function enumToArray(object: any){
    const toReturn = [];
    for(const prop in object){
        if (isNaN(Number.parseInt(prop))){
            toReturn.push({name: prop, value: object[prop]});
        }
    }
    return toReturn;
}

export function capitalize(val: string){
    if(!val){
        return "";
    }
    return val[0].toUpperCase() + val.slice(1)
}

export function cleanUpPhoneNumber(telephoneNumber: string)
{
    //eslint-disable-next-line
    return telephoneNumber?.replace(/[ |\/|\|\-|+|\(|\)]/gm, "") ?? "";
}

export function cleanUpLeadingZeroes(telephoneNumber: string)
{
    return telephoneNumber?.replace(/^0+/gm, "") ?? "";
}

export function appendPrefixIfMissing(phoneNumber: string)
{
    if(!phoneNumber.startsWith("00") && !phoneNumber.startsWith("+"))
    {
        phoneNumber = "+" + phoneNumber;
    }

    return phoneNumber;
}